import { render, staticRenderFns } from "./DiscountInput.vue?vue&type=template&id=46ca1256&"
import script from "./DiscountInput.vue?vue&type=script&lang=ts&"
export * from "./DiscountInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports